export enum AudioOptionButtonState {
  DISABLED = 0,
  INACTIVE = 1,
  ACTIVE = 2,
}
